module.exports = __webpack_public_path__ + "static/media/img_coin.8885f2d9.png";